/**
 * WorkOutcomeChip — the one chip that draws a §14C.1 work outcome (FULL-0099 / PROD-UX-013).
 *
 * Two ways in, and exactly one visual result for the same fact:
 *   - `status` — a stored `AgentRun.status`, read through the shared vocabulary;
 *   - `outcome` — an outcome the calling surface has already derived (e.g. the workforce console's
 *     verified-outcome row, which only exists for an audited successful completion).
 *
 * The chip shell is `statusVocabulary.CHIP_CLS` and the tone is the shared arm's `cls`, so this is
 * not a second palette. `live-status-chip` is applied because `styles/liveStates.css` is where the
 * recolour transition lives AND where `prefers-reduced-motion: reduce` removes it — the class is
 * what makes the reduced-motion guarantee reach this chip rather than a claim about it.
 *
 * No `dir` is set. The chip carries Hebrew text and inherits the reading direction of the surface
 * that mounts it, which is what keeps it inside the page's RTL context instead of pinning its own.
 */
import { CHIP_CLS } from "./statusVocabulary";
import { workOutcomeForRunStatus, workOutcomeMeta } from "./workOutcomeVocabulary";

export default function WorkOutcomeChip({ status = null, outcome = null, testId, className = "" }) {
  const key = outcome != null ? outcome : workOutcomeForRunStatus(status);
  const meta = workOutcomeMeta(key);
  return (
    <span
      data-testid={testId}
      data-work-outcome={meta.key ?? "unknown"}
      title={meta.key ? meta.label : undefined}
      className={`${CHIP_CLS} live-status-chip ${meta.cls}${className ? ` ${className}` : ""}`}
    >
      {meta.label}
    </span>
  );
}
